// extracted by mini-css-extract-plugin
module.exports = {"news_box":"news_box-2tVwbQ7r clearfix","box":"box-19XkIEpF","box_l":"box_l-3ZDeWmZm","box_r":"box_r-31kE_Iy9","btn":"btn-3rPbbip1","txt_bg":"txt_bg-38vuscdT","txt":"txt-2vuKQEmE"};